import { defineComponent, h, VNodeChildren } from 'vue';
import { BaseActivity } from '@/entities/activity/model';
import { du } from '@/ui/i18n/i18n';
import { VNodeData } from 'vue/types/vnode.d';

interface CreatedAtProps {
  log: BaseActivity;
}

export const CreatedAt = defineComponent<CreatedAtProps>({
  name: 'CreatedAt',
  props: ['log'],
  setup(props, context) {
    return function render() {
      return h('div', { class: 'activity-logs__created-at' }, [
        context.slots.left ? context.slots.left() : null,
        du(props.log.createdAt, 'shortDateTime'),
      ]);
    };
  },
});

export function createdAt(data: VNodeData & { props: CreatedAtProps }, children: VNodeChildren = []) {
  return h(CreatedAt, data, children);
}
